import React, { PropsWithChildren } from 'react';
import Carousel, { CarouselProps } from 'nuka-carousel';
import styled from 'styled-components';
import { Button, Stack } from '@solvhealth/jigsaw-v1';
import { colors } from '../../constants/colors';
import { fontFamily, fontSize } from '../../constants/text';
import { downloadDriverCarouselVariants } from './util';
import { dotsDecorator } from '../../constants/sliders';
import SlideInBottomDialog from '../SolvDesignSystem/Dialog/SlideInBottomDialog';

const StyledCarousel = styled(Carousel).withConfig({ componentId: 'sc-yh7ram-0' })<PropsWithChildren<CarouselProps>>`
  height: 200px !important;
  margin: 40px 0 0;
  .paging-item.active .paging-dot {
    fill: ${colors.crunchBerry};
  }
  .paging-item .paging-dot {
    fill: ${colors.greyWorm};
  }
`;

const StyledImg = styled.img.withConfig({ componentId: 'sc-yh7ram-1' })`
  margin-bottom: 15px;
`;

const StyledCaption = styled.div.withConfig({ componentId: 'sc-yh7ram-2' })`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: ${fontFamily.medium};
  font-size: ${fontSize.medium};
`;

type Props = {
  onClose?: (...args: any[]) => any;
  handleAppClick?: (...args: any[]) => any;
  visible?: Boolean;
};

const DownloadDriverCarousel = (props: Props) => {
  const { visible, handleAppClick, onClose } = props;

  if (!visible) return null;

  const variantCaptions = downloadDriverCarouselVariants.default;

  return (
    <SlideInBottomDialog open shouldOffsetBottomNav={false}>
      <StyledCarousel
        autoplay
        renderBottomCenterControls={dotsDecorator}
        renderCenterLeftControls={() => null}
        renderCenterRightControls={() => null}
      >
        {variantCaptions.map((caption) => (
          <StyledCaption key={caption.title}>
            <StyledImg alt={caption.title} src={caption.img} width="128px" />
            <span style={{ fontSize: '20px', textAlign: 'center' }}>
              {caption.title}
              <br />
              {caption.title2}
            </span>
          </StyledCaption>
        ))}
      </StyledCarousel>
      <Stack mt="48px">
        <Button onClick={handleAppClick}>Switch to the app</Button>
        <Button onClick={onClose} variant="text">
          Continue in browser
        </Button>
      </Stack>
    </SlideInBottomDialog>
  );
};

export default DownloadDriverCarousel;
